import { ReportHeaderProps } from "./types";
import {
	THCell,
	Box,
	TableSortLabel,
	LMUICSSObject
} from "@launchmetrics/lm-ui";
import { useStyles } from "./styles";
import React from "react";

const ReportHeader = (props: ReportHeaderProps) => {
	const { header } = props;
	const styles = useStyles();

	const cellStyles: LMUICSSObject = React.useMemo(
		() => ({
			...styles.tableCellStyles,
			...(header.sortable ? styles.tableCellSortedStyles : {}),
			width: header.width,
			maxWidth: header.maxWidth,
			color: header.highlighted ? "primary.500" : "text.default"
		}),
		[
			header.highlighted,
			header.maxWidth,
			header.sortable,
			header.width,
			styles.tableCellSortedStyles,
			styles.tableCellStyles
		]
	);

	return (
		<THCell
			id={header.name}
			key={header.name}
			sortable={header.sortable}
			defaultSort={header.defaultSort}
			disablePaddingXOnSort={false}
			styleProps={cellStyles}
		>
			{(() => {
				const headerContent = (
					<Box
						styleProps={styles.headerCellContentStyles}
						as={"div"}
						title={header.name}
					>
						{ header.alias }
					</Box>
				);
				return header.sortable ? (
					<TableSortLabel>{headerContent}</TableSortLabel>
				) : (
					headerContent
				);
			})()}
		</THCell>
	);
};

export default ReportHeader;
